import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';

class WtModalConfirmDeleteController implements angular.IComponentController {
    static $inject = [];
}

export const wtModalConfirmDelete: ComponentDefinition = {
    componentId: 'wtModalConfirmDelete',
    controller: WtModalConfirmDeleteController,
    controllerAs: 'vm',
    template: require('./modalConfirmDelete.compoment.html'),
    bindings: {
        delete: '&',
        name: '@',
        modalId: '@'
    }
};